/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DoctorIcon.vue?vue&type=template&id=162eb0ce"
import script from "./DoctorIcon.vue?vue&type=script&lang=js"
export * from "./DoctorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('162eb0ce')) {
      api.createRecord('162eb0ce', component.options)
    } else {
      api.reload('162eb0ce', component.options)
    }
    module.hot.accept("./DoctorIcon.vue?vue&type=template&id=162eb0ce", function () {
      api.rerender('162eb0ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/DoctorIcon.vue"
export default component.exports